import React from "react";
import { Heading, Link } from "@flixbus/honeycomb-react";
import { Icon, IconInfoSolid } from "@flixbus/honeycomb-icons-react";
import styles from "./CalculationInputNoMatches.module.scss";

interface CalculationInputNoMatchesProps {
  onClearFilters: () => void;
}

const CalculationInputNoMatches: React.FC<CalculationInputNoMatchesProps> = ({
  onClearFilters,
}) => (
  <div className={styles.container}>
    <Icon InlineIcon={IconInfoSolid} size={6} extraClasses={styles.icon} />
    <Heading size={4} flushSpace>
      No calculations match these filters
    </Heading>
    <Link
      onClick={(e) => {
        e.preventDefault();
        onClearFilters();
      }}
      href="#"
    >
      Clear filters
    </Link>
  </div>
);

export default React.memo(CalculationInputNoMatches);
